import React from "react";

import { Box, BoxProps } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { Skeleton } from '@mui/material';

const useStyles = makeStyles(() => ({
  loading: {
    transform: "none",
  },
  loading2: {
    transform: "none",
    marginTop: "16px",
  },
}));

type Props = BoxProps;

export const EditEquipmentLoading: React.FC<Props> = (props) => {
  const classes = useStyles();

  return (
    <Box {...props}>
      <Skeleton height="268px" width="100%" className={classes.loading} />
      <Skeleton height="588px" width="100%" className={classes.loading2} />
    </Box>
  );
};
